export default [
	'online_configuration',
]